import { LoadingLarge, Select, SelectOption, SelectOptionGroup } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { createUseStyles } from 'react-jss';
import featureFlags from '../enums/feature-flags';
import { DASHBOARD_LOCATIONS } from '../enums/holistics-dashboard-enums';
import checkFeature from '../helpers/check-feature-flag';
import routePaths from '../route-paths';
import { TitleService } from '../services';
import { Breadcrumbs } from '../store';

const useStyles = createUseStyles({
  reportWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 16,
    backgroundColor: '#f6f7f8',
    minHeight: '100vh',
  },
  reportContainer: {
    backgroundColor: '#f6f7f8',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '90%',
    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },
  },
  select: {
    width: 523,
    marginBottom: 8,
  },
  loadingContainer: {
    height: 'calc(100vh - 75px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const DemoDashboard = ({ history, locationDefault }) => {
  const classes = useStyles();
  const [selectedReport, setSelectedReport] = useState([{ value: 'demo-landing-dashboard', text: 'Spoiler Alert - Dashboard' }]);
  const [loading, setLoading] = useState(false);
  const url = `${window.location.origin}/assets`;

  const dropdownOptions = [
    <SelectOptionGroup key="core" name="CORE" search>
      <SelectOption key="dashboard" value="demo-landing-dashboard">
        {'Spoiler Alert - Dashboard'}
      </SelectOption>
      <SelectOption key="leftover" value="demo-leftover-dashboard">
        {'Spoiler Alert - Leftover Report'}
      </SelectOption>
      <SelectOption key="performance" value="demo-performance-dashboard">
        {'Spoiler Alert - Program Performance Report'}
      </SelectOption>
      <SelectOption key="shelfLife" value="demo-shelfLife-dashboard">
        {'Spoiler Alert - Shelf Life Report'}
      </SelectOption>
    </SelectOptionGroup>,
  ];

  useEffect(() => {
    const landingPageEnabled = checkFeature(featureFlags.landingPage);
    if (landingPageEnabled && locationDefault !== DASHBOARD_LOCATIONS.REPORTS_TAB) {
      history.push(routePaths.landingPage);
    }
  }, []);

  useEffect(() => {
    TitleService.setTitles('Reports');
    Breadcrumbs.set([
      {
        url: routePaths.dashboard,
        title: 'Reports',
      },
    ]);
  }, []);

  useEffect(() => {
    if (history.location.pathname === routePaths.reportsDashboard) {
      setSelectedReport([{ value: 'demo-performance-dashboard', text: 'Spoiler Alert - Program Performance Report' }]);
      setLoading(false);
    } else {
      setSelectedReport([{ value: 'demo-landing-dashboard', text: 'Spoiler Alert - Dashboard' }]);
      setLoading(false);
    }
  }, [history.location.pathname]);

  const selectedReportImage = useMemo(() => {
    const report = selectedReport[0]?.value;
    if (report) {
      return <img src={`${url}/${report}.png`} alt={report} />;
    }
    return null;
  }, [selectedReport, url]);

  const handleReportChange = async (value) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 250)); // Simulate a delay
    setLoading(false);
    setSelectedReport(value);
  };

  return (
    <div>
      <Select containerClassName={classes.select} label="Select report" search selectedItems={selectedReport} onChange={handleReportChange}>
        {dropdownOptions}
      </Select>
      <div className={classes.reportWrapper}>
        {loading ? (
          <div className={classes.loadingContainer}>
            <LoadingLarge />
          </div>
        ) : (
          <div className={classes.reportContainer}>{selectedReportImage}</div>
        )}
      </div>
    </div>
  );
};

export default DemoDashboard;

DemoDashboard.propTypes = {
  history: PropTypes.object.isRequired,
  locationDefault: PropTypes.string,
};
